const glossaryPages = [
  {
    id: 'data-object',
    name: 'Data Objects',
    singularName: 'Data Object',
    default: true
  },
  {
    id: 'data-element',
    name: 'Data Elements',
    singularName: 'Data Element'
  },
  {
    id: 'data-type',
    name: 'Data Types',
    singularName: 'Data Type'
  },
  {
    id: 'data-domain',
    name: 'Data Domains',
    singularName: 'Data Domain'
  },
  {
    id: 'sample-value',
    name: 'Sample Values',
    singularName: 'Sample Value'
  }
]

export default glossaryPages
export const getDefaultPage = () => glossaryPages.filter(item => 'default' in item && item.default )[0].id
export const getCurrentPage = page => glossaryPages.filter(item => item.id === page)[0] ?? glossaryPages.filter(item => 'default' in item && item.default )[0]